import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-not-selected',
  templateUrl: './chat-not-selected.component.html',
  styleUrls: ['./chat-not-selected.component.scss']
})
export class ChatNotSelectedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
